import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import {
    getCreateCourseDefaultFormData,
    getCreateCourseInitailStateForErrors,
    checkMinLength,
    isNumericInput,
    checkStartAndEndDate,
    buildSKUString,
    isContainSpecialCharacters,
} from '../../helpers/helpers';

import {
    CourseBasicDetails,
    CourseBasicDetailsErrors,
} from '../../types/interfaces/CourseBasicDetails';
import { Goal } from '../../types/interfaces/Goal';
import { User } from '../../types/interfaces/User';
import DialogHeader from '../../../userManagement/common/DialogHeader';
import DialogFooter from '../../../userManagement/common/DialogFooter';

import {
    withStyles,
    WithStyles,
    Card,
    CardContent,
    CardActions,
    Checkbox,
    Typography,
    Modal,
    CardHeader,
    IconButton,
    Button,
    Grid,
    FormControl,
    FormControlLabel,
    FormGroup,
    Radio,
    Icon,
    Switch,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import {
    MyPATTextField,
    MyPATDialog,
    MyPATSelect,
    dateService,
    MyPATMultiSearch,
} from '../../../common';
import CloseIcon from '@material-ui/icons/Close';
import { courseStyles } from '../../styles';
import MyPATCalendar from '../../../common/MyPATCalendar';
import Autocomplete from '../../../common/Autocomplete';
import {
    getActiveGoals,
    getUserSuggestions,
    addCourseBasicDetails
} from '../../actions/courseManagementActions';
import _ from 'lodash';
import { ContentPreferences } from '../../types/enums/ContentPreferences';
import { DateCheck } from '../../types/enums/DateCheckResults';
import SearchBarWithChips from '../../common/SearchBarWithChips';
import ACLService from '../../../acl/services/aclService';
import { onlyAllowNumbers } from '../../../../utils';
import CreateCoursePopup from '../CreateCoursePopup/CreateCoursePopup';
import { CourseTypes } from '../../types/enums/CourseTypes';
import { getFormValues } from 'redux-form';
import { durationMap, getCourseDurationByDate } from './helper/getCourseDurationByDates';

interface CreateNewCourseProps {
    goals: Goal[];
    userSuggestions: User[];
    getActiveGoals: Function;
    getUserSuggestions: Function;
    addCourseBasicDetails: Function;
    classes: any;
    packageId: string;
    history: any;
    location: any;
    duplicateSKUMessage: string;
}

interface CreateNewCourseState {
    formData: CourseBasicDetails;
    formErrors: CourseBasicDetailsErrors;
    activateCreateCourseBtn: boolean;
    activeGoals: string[];
    userSuggestions: any[];
    removedSuggestions: any[];
    loggedInUserFullName: string;
    clientId: string;
    courses: string[],
    selectedCourse: string,
    values: {value: string, label: string, id: string}[],
    userId: string;
    shareViewRights:boolean,
    isMyPatClient:boolean
}
class CreateNewCourse extends Component<
    CreateNewCourseProps,
    CreateNewCourseState
> {
    constructor(props: CreateNewCourseProps) {
        super(props);
        const userData = ACLService.getUserDetailsFromStorage();
        const fullName = userData.authenticatedUser.fullName;
        const clientID = userData.authenticatedUser.id;
        this.state = {
            formData: getCreateCourseDefaultFormData({
                id: clientID,
                firstName: fullName.split(' ')[0],
                lastName: fullName.split(' ')[1],
                isRemovable: false
            }),
            formErrors: getCreateCourseInitailStateForErrors(),
            activateCreateCourseBtn: false,
            activeGoals: [],
            userSuggestions: [],
            removedSuggestions:[],
            loggedInUserFullName: '',
            clientId: '',
            courses: ["Standard Course", "Goals"],
            selectedCourse: "",
            values:[],
            userId: '',
            shareViewRights:false,
            isMyPatClient:false
        };
    }

    componentDidMount() {
        const userData = ACLService.getUserDetailsFromStorage();
        // console.log(userData);
        const clientId = userData.authenticatedUser.aclMetaData.clientId;
        const fullName = userData.authenticatedUser.fullName;
        const clientID = userData.authenticatedUser.id;
        const userId = userData.authenticatedUser._id
        // console.log(clientId);
        // console.log(this.props.goals);
        // console.log(this.props.userSuggestions);
        const { values } = this.state
        let updatedValues = [...values, { label: `${fullName} (You)`, value: fullName, id: clientID, isRemovable: false}]
        this.props.getActiveGoals();
        this.props.getUserSuggestions({
            clientId: clientId,
        });
        this.setState({
            loggedInUserFullName: fullName,
            clientId: clientID,
            values: updatedValues,
            userId,
            isMyPatClient:clientId=="5b5702e095cbc921944632a9"
        }, () => this.updateUserSuggestions())
    }

    componentDidUpdate(prevProps: CreateNewCourseProps) {
        if (prevProps.goals !== this.props.goals) {
            // console.log(this.props.goals);
            this.setActiveGoals(this.props.goals);
        }

        if (prevProps.userSuggestions !== this.props.userSuggestions) {
            // console.log(this.props.userSuggestions);
            const fullNames = this.prepareAdminNameSuggestions(
                this.props.userSuggestions
            );
            console.log(fullNames)
            this.setState({
                userSuggestions: fullNames,
            }, () => this.updateUserSuggestions());
        }

        if(prevProps.duplicateSKUMessage !== this.props.duplicateSKUMessage){
            const updatedFormErrors = {...this.state.formErrors}
            const updatedSKU = {...updatedFormErrors.sku}
            updatedSKU.SKUText = this.props.duplicateSKUMessage[0]
            updatedFormErrors.sku = updatedSKU
            this.setState({
                formErrors: updatedFormErrors
            })
        }

        // UNCOMMENT BELOW!
        if (prevProps.packageId !== this.props.packageId) {
            console.log(this.props.packageId)
            this.props.history.replace(`/course-Management/create-standard-course/${this.props.packageId}`)
        }
    }

    setActiveGoals = (goalData: Goal[]) => {
        const goalNameArray = goalData.map((goal) => goal.name);
        this.setState({
            activeGoals: goalNameArray,
        });
    };

    validateFormData = (field: string, data?: any) => {
        const { formData, formErrors } = this.state;
        let updatedFormErrors = JSON.parse(JSON.stringify(formErrors))

        let result;
        switch (field) {
            case 'name':
                console.log('name--->', data);
                console.log(checkMinLength(data, 5));

                result = checkMinLength(data, 5)
                    ? ''
                    : 'Enter atleast 5 characters';
                return result
                
            case 'sku.SKUText':
                result = isContainSpecialCharacters(data) ?'No Special Characters Allowed': checkMinLength(data, 3) ? '' : 'Enter atleast 3 characters';
                return result
                
            case 'sku.SKUNumber':
                console.log(data)
                result = checkMinLength(data.toString(), 1)
                    ? ''
                    : 'Enter atleast 1 character';
                
                return result;
                
                // DATE, Goal and package admin
            // case 'date':
            //     const dateCheckResult = checkStartAndEndDate(startDate.value, endDate.value);
            //     // console.log(dateCheckResult)
            //     switch (dateCheckResult) {
            //         case DateCheck.startGreaterThanEnd:
            //             updatedFormErrors.startDate = DateCheck.startGreaterThanEnd;
            //             break;
            //         case DateCheck.endLessThanStart:
            //             updatedFormErrors.endDate = DateCheck.endLessThanStart;
            //             break;
            //         default:
            //             updatedFormErrors.startDate = '';
            //             updatedFormErrors.endDate = ''
            //     }
            //     break;
            case 'goal':
       
                result = data.length > 0
                    ? ''
                    : 'Select a goal';
                return result;
                
            case 'courseAdmins':
                
                result  =  data !== null
                    ? ''
                    : 'Select atleast one course admin';
                return result

                break;
            default:
                return ''
        }

        console.log(updatedFormErrors)

    };

    canActivateCreateCourseBtn = () => {
        const { formErrors } = this.state;
        // console.log(formErrors);
        let activateCreateCourseBtn = false;

        if (
            formErrors.name === '' &&
            formErrors.sku.SKUText === '' &&
            formErrors.sku.SKUNumber === '' &&
            formErrors.courseDetails === '' &&
            formErrors.startDate === '' &&
            formErrors.endDate === '' &&
            formErrors.contentPreferences === '' &&
            formErrors.packageAdmins === ''
        ) {
            console.log(':::::TRUE::::::')
            activateCreateCourseBtn = true;
        } else {
            console.log(':::::FALSE::::::')
            activateCreateCourseBtn = false;
        }

        this.setState(
            {
                activateCreateCourseBtn: activateCreateCourseBtn,
            }
        );
    };

    handleChange = (event: any) => {
        const { name, value } = event.target;
        const updatedFormData = {...this.state.formData};
        // console.log('Form Data', updatedFormData);
        const updatedFormErrors = {...this.state.formErrors};
        console.log('Name ->', name);
        console.log('Value ->', value);
        let result;
        switch (name) {
            case 'name':
                const regex = /^[A-Za-z0-9 /(/)]+$/
                if(regex.test(value) || value === '') {
                  let processedValue = value.trimStart();
                  updatedFormData.name = processedValue;
                }
                if (updatedFormErrors.name === 'untouched') {
                    result = '';
                }
                result = this.validateFormData('name', value.trim());
                updatedFormErrors.name = result;
                break;
            case 'skuText':
                let updatedSKUFormData = {...updatedFormData.sku}
                updatedSKUFormData.SKUText = value.replace(/[^A-Z0-9]/ig, "");
                updatedFormData.sku = updatedSKUFormData;
                if (updatedFormErrors.sku.SKUText === 'untouched') {
                    result = ''
                }
                result = this.validateFormData('sku.SKUText', value.replace(/[^A-Z0-9]/ig, ""));
                console.log(':::::result:::::', result)
                let updatedSKU = {...updatedFormErrors.sku}
                updatedSKU.SKUText = result;
                updatedFormErrors.sku = updatedSKU
                break;
            case 'skuNumber':
                let updatedSKUForm = {...updatedFormData.sku}
                updatedSKUForm.SKUNumber = value.replace(/[^\w\s]/gi, '');
                updatedFormData.sku = updatedSKUForm
                if (updatedFormErrors.sku.SKUNumber === 'untouched') {
                    result = ''
                }
                result = this.validateFormData('sku.SKUNumber', value.replace(/[^\w\s]/gi, ''));
                let updatedSku = {...updatedFormErrors.sku}
                updatedSku.SKUNumber = result;
                updatedFormErrors.sku = updatedSku
                break;
            case 'goal':
                updatedFormData.courseDetails = value;
                if (updatedFormErrors.courseDetails === 'untouched') {
                    updatedFormErrors.courseDetails = '';
                }
                const SKUYear = value.split('-');
                const updatedSKUObj = {...updatedFormData.sku}
                updatedSKUObj.SKUYear = SKUYear[SKUYear.length - 1];
                updatedFormData.sku  = updatedSKUObj;
                
                result = this.validateFormData('goal', value);
                updatedFormErrors.courseDetails = result;
                break;
            case 'CourseCreated':
                this.setState({
                    selectedCourse: value
                })
                console.log(name, value);
                break;
            case 'courseDuration':
                updatedFormData.duration = value;
                
                break;
            default:
        }
        this.setState(
            {
                formData: updatedFormData,
                formErrors: updatedFormErrors,
            },
            () => {
                console.log(this.state.formData);
                this.canActivateCreateCourseBtn();
            }
        );
    };

    handleDateSelection = (date: any, type: string) => {
        console.log(date);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const updatedFormData = { ...this.state.formData };
        const updatedFormErrors = { ...this.state.formErrors };
        const formattedDate = dateService.dateOnly(date);

        const newDate = new Date(date.toString());
        const day = (newDate.getDate() < 10) ? `0${newDate.getDate()}` : (newDate.getDate());
        const month = (newDate.getMonth() + 1) < 10 ? `0${newDate.getMonth() + 1}` : (newDate.getMonth() + 1);
        const year = newDate.getFullYear();
        const fullDate = `${year}-${month}-${day}`

        // console.log(formattedDate);
        switch (type) {
            case 'startDate':
                updatedFormData.startDate.label = formattedDate;
                updatedFormData.startDate.value = fullDate;
                updatedFormErrors.startDate = '';
                this.validateFormData('date');
                break;
            case 'endDate':
                updatedFormData.endDate.label = formattedDate;
                updatedFormData.endDate.value = fullDate;
                updatedFormErrors.endDate = '';
                this.validateFormData('date');
                const courseDuration = getCourseDurationByDate(updatedFormData.startDate.value, 
                                                               fullDate);
                
                updatedFormData.duration = courseDuration;
                
                break;
            default:
        }
        this.setState(
            {
                formData: updatedFormData,
                formErrors: updatedFormErrors,
            },
            () => {
                console.log(this.state.formData);
                this.canActivateCreateCourseBtn();
            }
        );
    };

    handleToggle = (contentType: string) => {
        // console.log(contentType);
        const updatedFormData = this.state.formData;
        const updatedFormErrors = this.state.formErrors;
        switch (contentType) {
            case ContentPreferences.conceptTests:
                updatedFormData.contentPreferences.conceptTests.enabled = !updatedFormData
                    .contentPreferences.conceptTests.enabled;
                break;
            case ContentPreferences.video:
                updatedFormData.contentPreferences.video.enabled = !updatedFormData
                    .contentPreferences.video.enabled;
                break;
            case ContentPreferences.chapterTests:
                updatedFormData.contentPreferences.chapterTests.enabled = !updatedFormData
                    .contentPreferences.chapterTests.enabled;
                break;
            case ContentPreferences.studyNotes:
                updatedFormData.contentPreferences.studyNotes.enabled = !updatedFormData
                    .contentPreferences.studyNotes.enabled;
                break;
            case ContentPreferences.scheduledTests:
                updatedFormData.contentPreferences.scheduledTests.enabled = !updatedFormData
                    .contentPreferences.scheduledTests.enabled;
                break;
            default:
        }

        if (
            updatedFormData.contentPreferences.conceptTests.enabled ||
            updatedFormData.contentPreferences.video.enabled ||
            updatedFormData.contentPreferences.chapterTests.enabled ||
            updatedFormData.contentPreferences.studyNotes.enabled ||
            updatedFormData.contentPreferences.scheduledTests.enabled
        ) {
            updatedFormErrors.contentPreferences = '';
        } else {
            updatedFormErrors.contentPreferences =
                'Select atleast one content preference.';
        }

        this.setState(
            {
                formData: updatedFormData,
                formErrors: updatedFormErrors,
            },
            () => {
                // console.log(this.state.formData.contentPreferences);
                this.canActivateCreateCourseBtn();
            }
        );
    };

    // renderSelectGoalOptions = () => {
    //     let options = [];
    //     options.push(<option value={''}>{'Select Goal'}</option>);
    //     _.map(this.state.activeGoals, (goal: string, index: number) =>
    //         options.push(
    //             <option key={index} value={goal}>
    //                 {goal}
    //             </option>
    //         )
    //     );
    //     return options;
    // };

    getGoalSuggestions = () => {
      return (this.state.activeGoals || []).map((goal, i) => {
        return {
          id: i,
          label: goal,
          value: goal
        }
      })
    }

    prepareAdminNameSuggestions = (data: User[]) => {
        // {label: 'Adam'}
        const { loggedInUserFullName } = this.state
        let users = data
            .map((user) => {
                if (user.firstName !== undefined && 
                    user.firstName !== null 
                    // && 
                    // user.lastName !== null && 
                    // user.lastName !==undefined && 
                    // user.lastName.length > 0
                    )
                    return user;
            })
            .filter((user) => user !== undefined)
            .map((user) => ({
                id: user && user._id,
                label: `${user && user.firstName} ${user &&
                    user.lastName !== null &&
                    user.lastName !== undefined &&
                    user.lastName}`,
            }));
        // console.log(users);
        users = users.filter((user) => !loggedInUserFullName.includes(`${user.label}`))

        return users;
    };

    handleCourseAdminNames = (
        names: { value: string; label: string; id: string }[]
    ) => {
        console.log('IN HAndle Course Names------------>', names);
        const validationResult = this.validateFormData('courseAdmins', names);
        let updatedFormErrors = {...this.state.formErrors};
        if (names !== null) {
            this.updateUserSuggestions();
            const admins = names.filter((name) => name.id);
            console.log(admins);
            let selectedAdmins: any = [];
            admins.forEach((admin) => {
                const currentUser = this.props.userSuggestions.filter(
                    (user) => user._id === admin.id
                );
                selectedAdmins.push(currentUser[0]);
            });
            console.log(selectedAdmins)
            const trimmedAdminObjects = selectedAdmins.map((admin: User) => ({
                id: admin._id,
                firstName: admin.firstName,
                lastName: admin.lastName,
                isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ?  false : true,
            }));
            console.log(trimmedAdminObjects);

            let updatedValues = trimmedAdminObjects.map((admin: any) => ({
                label: this.state.loggedInUserFullName.toString().includes(`${admin.firstName} ${admin.lastName}`) ? `${admin.firstName} ${admin.lastName} (You)` : `${admin.firstName} ${admin.lastName}`,
                value: this.state.loggedInUserFullName.toString().includes(`${admin.firstName} ${admin.lastName}`) ? `${admin.firstName} ${admin.lastName} (You)` : `${admin.firstName} ${admin.lastName}`,
                id: admin.id,
                // isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ?  false : true
                isRemovable: this.state.userId === admin.id ? false : true
            }))
            console.log('UPDATED VALUES--------->', updatedValues)


            this.canActivateCreateCourseBtn();
            this.setState((prevState:any)=>{
                let { formData } = prevState;
                let { packageAdmins } = formData;
                
                let updatedFormData = {...formData}
                let updatedPackageAdmins = [...trimmedAdminObjects]
    
                // packageAdmins = trimmedAdminObjects;
                updatedFormData.packageAdmins = updatedPackageAdmins;
    
                updatedFormErrors.packageAdmins = validationResult;
                return {
                    formData: updatedFormData,
                    formErrors: updatedFormErrors,
                    values: updatedValues
                };
             },
                () => {
                    console.log(this.state.formData);

                    this.canActivateCreateCourseBtn();
                    this.updateUserSuggestions();
                }
            );
        } else {
            console.log('IN Handle Admin NAmes ELSE---------')
            let { formData } = this.state;
            let { packageAdmins } = formData;
            let updatedFormData = {...formData}
            let updatedPackageAdmins = [...packageAdmins]
            // updatedPackageAdmins = [];
            updatedFormData.packageAdmins = updatedPackageAdmins;
            this.setState({
                formData: updatedFormData
            }, () => this.canActivateCreateCourseBtn())
        }
    };

    updateUserSuggestions = () => {
        let { userSuggestions: allUserSuggestions } = this.props;
        const { formData, userSuggestions, values, loggedInUserFullName } = this.state;
        // console.log('All User Suggestions', allUserSuggestions)
        // console.log('User Suggestions', userSuggestions)
        console.log('Values', values)
        const { packageAdmins } = formData;
        let updatedUserSuggestions:any = [];
        let updatedRemovedSuggestions: any = [];
        // console.log('Package Admins', packageAdmins)
    
        allUserSuggestions.forEach((user) => {
            
            // if(user.firstName !== null && user.lastName !== null) {
              let addCurrentUser = true;
              const fullName = `${user.firstName} ${user.lastName}`
              values.forEach((admin) => {
                  // const adminFullName = `${admin.firstName} ${admin.lastName}`
                  if(admin.label.includes(fullName)){
                      console.log(user)
                      updatedRemovedSuggestions.push({id:user._id, label: fullName})
                      addCurrentUser = false;
                  }
              })
              if(addCurrentUser){
                  updatedUserSuggestions.push({id:user._id, label: fullName})
              }
            // }
            
        })
        this.setState({
            userSuggestions: updatedUserSuggestions,
            removedSuggestions: updatedRemovedSuggestions
        }, () => console.log(this.state.removedSuggestions))
    }

    prepareCourseDetailArray = () => {
        console.log(this.props.goals)
        console.log(this.state.formData.courseDetails)
        const goal = this.props.goals.filter((goal) => goal.name === this.state.formData.courseDetails || goal.name === this.state.formData.courseDetails[0].courseName);
        console.log(goal);
        const goalData = [{
            courseId: goal[0]._id,
            courseType: goal[0].courseType,
            courseName: goal[0].name
        }]
        return goalData;
    }

    handleSubmit = () => {
        const { formData } = this.state;
        let updatedFormdata = {...formData}
        console.log(formData);
        updatedFormdata.name = formData.name.trim(); 
        updatedFormdata.type = CourseTypes.standard;
        updatedFormdata.targetYears = [formData.sku.SKUYear];
        const goalData = this.prepareCourseDetailArray();
        updatedFormdata.courseDetails = goalData;
        updatedFormdata.sku = buildSKUString(this.state.formData.sku);
        updatedFormdata.startDate = formData.startDate.value;
        updatedFormdata.expiryDate = formData.endDate.value;
        console.log(updatedFormdata);
        updatedFormdata.isSharedWithFiitjeeClients=this.state.shareViewRights;
        this.props.addCourseBasicDetails(updatedFormdata);  

    };
    handleSelectedCourses = () => {
    }

    getSearchBarChipValues = () => {
        const { formData } = this.state;
        const { packageAdmins } = formData



        return [{
            label: this.state.loggedInUserFullName,
            value: this.state.loggedInUserFullName,
            id: this.state.clientId
        }]
    }

    getCourseDurationOptions = () => {
      let options = [];
      options.push(<option value={0}>{'Select Course Duration'}</option>);
      _.map(durationMap, (duration: {label: string, value: number}, index: number) =>
            options.push(
              <option key={index} value={duration.value}>
                  {duration.label}
              </option>
          )
      );
      return options;
    }
    setShareEditKey=()=>{
        this.setState({shareViewRights:!this.state.shareViewRights});
    } 
    render() {
        const { classes } = this.props;
        // const { location } = this.props;
        // console.log(this.state.formErrors);
        console.log('User Suggestions ->',this.state.userSuggestions);
        console.log('Values ->',this.state.values);

        const startDate = this.state.formData.startDate.value ?
            new Date(this.state.formData.startDate.value) :
            this.state.formData.startDate.value

        const endDate = this.state.formData.endDate.value ?
            new Date(this.state.formData.endDate.value) :
            this.state.formData.endDate.value

        // console.log(this.state.loggedInUserFullName);
        // console.log(this.props.location.pathname === "/course-Management/create-standard-course");
        // console.log('::::::formErrors::::::::::', this.state.formErrors)


        const goalSuggestions = this.getGoalSuggestions()

        const { duration } = this.state.formData;
        const relevantDurationIndex = durationMap.filter((durationObj:any, index: number) => {
          if(+Object.keys(durationObj)[0] === duration){
            return index
          }
        });

        return (
          <Modal
          BackdropProps={{ invisible: true }}
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          hideBackdrop={true} //@Neeraj: try to follow the Material UI doc for UI Arch
          className={[
            classes.fontSizeLG,
            classes.fontWeight500,
            classes.modal,
          ].join(" ")}
          open={true}
        >
          <div className={classes.paper}>
            <Card
              elevation={0}
              classes={{ root: classes.cardContainer }}
            >
              <DialogHeader
                urlName="/course-Management"
                selectedTab="Clients"
                iconNode={
                  <IconButton
                    aria-label="settings"
                    // onClick={dialogCloseHandler}
                  >
                    <CloseIcon
                    // className={classes.fontSizeLG}
                    />
                  </IconButton>
                }
                headerTitle={
                  <>
                    <Typography className={classes.courseTitle}>
                      Create New Course
                    </Typography>
                  </>
                }
              />

              <CardContent className={classes.cardContentStyle}>
                <Grid container justify="center">
                  <Grid item xs={9}>
                    <Typography className={classes.cardHeading}>
                      Course Basic Details<span>*</span>{" "}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={8} justify="center">
                  <Grid item xs={9}>
                    <Grid container spacing={16}>
                      <Grid item xs={6}>
                        <Typography className={classes.inputLable}>
                          Course Name
                        </Typography>
                        <MyPATTextField
                          //   className={classes.inputWidth}
                          fullWidthControl
                          inputId="name"
                          name="name"
                          placeholder="Course Name"
                          // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                          value={this.state.formData.name || ""}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.state.formErrors.name !== "" &&
                            this.state.formErrors.name !== "untouched"
                              ? true
                              : false
                          }
                          errorText={this.state.formErrors.name}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography className={classes.inputLable}>
                          SKU
                        </Typography>
                        <Grid container spacing={16}>
                          <Grid item xs={6}>
                            <MyPATTextField
                              //   className={classes.inputWidth}
                              fullWidthControl
                              inputId="skuText"
                              name="skuText"
                              placeholder="E.g. JEE"
                              // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                              value={
                                this.state.formData.sku.SKUText || ""
                              }
                              onChange={this.handleChange.bind(this)}
                              error={
                                this.state.formErrors.sku.SKUText !==
                                  "" &&
                                this.state.formErrors.sku.SKUText !==
                                  "untouched"
                                  ? true
                                  : false
                              }
                              errorText={
                                this.state.formErrors.sku.SKUText
                              }
                            />
                            <span className={classes.smallInfo}>
                              Atleast 3 characters{" "}
                            </span>
                          </Grid>

                          <Grid item xs={6}>
                            <MyPATTextField
                              //   className={classes.inputWidth}
                              fullWidthControl
                              inputId="skuNumber"
                              name="skuNumber"
                              placeholder="01"
                              // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                              value={
                                this.state.formData.sku.SKUNumber || ""
                              }
                              onChange={this.handleChange.bind(this)}
                              error={
                                this.state.formErrors.sku.SKUNumber !==
                                  "" &&
                                this.state.formErrors.sku.SKUNumber !==
                                  "untouched"
                                  ? true
                                  : false
                              }
                              errorText={
                                this.state.formErrors.sku.SKUNumber
                              }
                              onKeyPress={onlyAllowNumbers}
                            />
                            <span className={classes.smallInfo}>
                              Value must be numeric{" "}
                            </span>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={16}
                      className={classes.mt30}
                    >
                      {/* Start: Use this code format for UI design as per figma for standard course*/}
                      <Grid item xs={6}>
                        <Typography className={classes.inputLable}>
                          Goal
                        </Typography>
                        <MyPATMultiSearch
                          options={goalSuggestions}
                          labelKey="label"
                          valueKey="value"
                          onChange={({ label }: any, name: string) => this.handleChange({ target: { name, value: label } })}
                          isSearchAble
                          name="goal"
                          placeholderText="Select Goal"
                          showAllOptionsOnFocus
                        />
                        {/* <MyPATSelect
                          value={this.state.formData.courseDetails}
                          name="goal"
                          onChange={(e: any) => this.handleChange(e)}
                        >
                          {this.renderSelectGoalOptions()}
                        </MyPATSelect> */}
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container spacing={16}>
                          <Grid
                            item
                            xs={6}
                            className={classes.customCalendar}
                          >
                            <Typography className={classes.inputLable}>
                              Start Date{" "}
                            </Typography>
                            <MyPATCalendar
                              fullWidthControl
                              onChange={(dateVal: string) =>
                                this.handleDateSelection(
                                  dateVal,
                                  "startDate"
                                )
                              }
                              date={this.state.formData.startDate.label}
                              placeholder="Select Start Date"
                              // minDate={new Date()}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            className={classes.customCalendar}
                          >
                            <Typography className={classes.inputLable}>
                              End Date
                            </Typography>
                            <MyPATCalendar
                              fullWidthControl
                              onChange={(dateVal: string) =>
                                this.handleDateSelection(
                                  dateVal,
                                  "endDate"
                                )
                              }
                              date={this.state.formData.endDate.label}
                              disabled={!startDate}
                              placeholder="Select End Date"
                              minDate={startDate}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* End: Use this code format for UI design as per figma */}
                      {/* <Grid item xs={12}>
                <>
                <Typography className={classes.inputLable}>
                    Goal
                  </Typography>
                  <MyPATSelect
                    // inputId={featurePermission}
                    value={this.state.formData.courseDetails}
                    name="goal"
                    onChange={(e: any) => this.handleChange(e)};
                    // disabled={!this.state.formData.client.isBranchClient}
                    // inputClass={classes.selectOrgStyle}
                  >
                    {this.renderSelectGoalOptions()}
                  </MyPATSelect>
                </>
              </Grid> */}
                    </Grid>

                    <Grid container spacing={16} justify="flex-start">
                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel
                          className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.formData.contentPreferences
                                  .conceptTests.enabled
                              }
                              onChange={() =>
                                this.handleToggle(
                                  ContentPreferences.conceptTests
                                )
                              }
                            />
                          }
                          label="Do you want Concept Test in this course?"
                          labelPlacement="start"
                        />
                        {/* </FormGroup> */}
                      </Grid>

                      <Grid item xs={6}>
                        {/* <FormGroup> */}
                        <FormControlLabel
                          className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.formData.contentPreferences
                                  .video.enabled
                              }
                              onChange={() =>
                                this.handleToggle(
                                  ContentPreferences.video
                                )
                              }
                            />
                          }
                          label="Do you want Videos in this course?"
                          labelPlacement="start"
                        />
                        {/* </FormGroup> */}
                      </Grid>
                    </Grid>
                      <Grid container spacing={16} justify="flex-start">
                        <Grid item xs={6}>
                          {/* <FormGroup> */}
                          <FormControlLabel
                            className={classes.updateLabel}
                            control={
                              <Switch
                                classes={{
                                  root: classes.swithMain,
                                  icon: classes.switchIcon,
                                  bar: classes.switchBar,
                                  iconChecked: classes.IscheckedSwitch,
                                  checked: classes.checkedSwitch,
                                }}
                                color="primary"
                                checked={
                                  this.state.formData.contentPreferences
                                    .chapterTests.enabled
                                }
                                onChange={() =>
                                  this.handleToggle(
                                    ContentPreferences.chapterTests
                                  )
                                }
                              />
                            }
                            label="Do you want Chapter Test in this course?"
                            labelPlacement="start"
                          />
                          {/* </FormGroup> */}
                        </Grid>

                        <Grid item xs={6}>
                          {/* <FormGroup> */}
                          <FormControlLabel
                            className={classes.updateLabel}
                            control={
                              <Switch
                                classes={{
                                  root: classes.swithMain,
                                  icon: classes.switchIcon,
                                  bar: classes.switchBar,
                                  iconChecked: classes.IscheckedSwitch,
                                  checked: classes.checkedSwitch,
                                }}
                                color="primary"
                                checked={
                                  this.state.formData.contentPreferences
                                    .studyNotes.enabled
                                }
                                onChange={() =>
                                  this.handleToggle(
                                    ContentPreferences.studyNotes
                                  )
                                }
                              />
                            }
                            label="Do you want Study Notes in this course?"
                            labelPlacement="start"
                          />
                          {/* </FormGroup> */}
                        </Grid>
                      </Grid>
                      <Grid container spacing={16} justify="flex-start">
                        <Grid item xs={6}>
                          {/* <FormGroup> */}
                          <FormControlLabel
                            className={classes.updateLabel}
                            control={
                              <Switch
                                classes={{
                                  root: classes.swithMain,
                                  icon: classes.switchIcon,
                                  bar: classes.switchBar,
                                  iconChecked: classes.IscheckedSwitch,
                                  checked: classes.checkedSwitch,
                                }}
                                color="primary"
                                checked={
                                  this.state.formData.contentPreferences
                                    .scheduledTests.enabled
                                }
                                onChange={() =>
                                  this.handleToggle(
                                    ContentPreferences.scheduledTests
                                  )
                                }
                              />
                            }
                            label="Do you want Scheduled Test in this course?"
                            labelPlacement="start"
                          />
                          {/* </FormGroup> */}
                        </Grid>
                      </Grid>
                    {/* </Grid> */}

                    <Grid
                      container
                      spacing={16}
                      className={[
                        classes.mt15,
                        classes.mb30,
                      ].join(" ")}
                    >

                      {/* <Grid item xs={6}> */}
                        {/* <Grid item xs={12}>
                        <Typography
                          className={[
                            classes.inputLable,
                            classes.mb0,
                          ].join(" ")}
                        >
                          Course Duration
                        </Typography>
                      </Grid> */}
                      {/* <Grid item xs={6} className={classes.mb30}>
                        <MyPATSelect
                          value={this.state.formData.duration}
                          name="courseDuration"
                          onChange={(e: any) => this.handleChange(e)}
                        >
                          {this.getCourseDurationOptions()}
                        </MyPATSelect>
                      </Grid> */}
                      {/* </Grid> */}


                      {/* <Grid item xs={12}> */}
                      <Grid item xs={6}>
                        <Typography
                          className={[
                            classes.inputLable
                          ].join(" ")}
                        >
                          Course Admin
                        </Typography>

                        <SearchBarWithChips
                          suggestions={this.state.userSuggestions}
                          placeholderText="Select Course Admins"
                          onSelection={this.handleCourseAdminNames}
                          // loggedInUserFullName={this.state.loggedInUserFullName}
                          classes={{ root: classes.searchBarChips }}
                          notFound="No User Found"
                          values={this.state.values}
                          isClearable={false}
                          backspaceRemoves={false}
                        />
                      </Grid>
                      <Grid item xs={6} className={classes.mb30}>
                      {this.state.isMyPatClient &&
                     <> 
                      <Grid>
                        <Typography
                        style={{marginTop: '20px'}}
                          className={[
                            classes.inputLable
                          ].join(" ")}
                        >
                          Share Course(with view and copy rights)
                        </Typography>
                      {/* </Grid>

                      <Grid item xs={6}> */}
                        <FormControlLabel
                          className={[classes.updateLabel, classes.updatedLabel].join(' ')}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                this.state.shareViewRights
                              }
                              onChange={() =>
                                this.setShareEditKey()
                              }
                            />
                          }
                          label="Share this course with FIITJEE Clients?"
                          labelPlacement="start"
                        />
                      </Grid>
                      </>}
                      </Grid>

                      </Grid>
                    </Grid>
                  </Grid>
                {/* </Grid> */}
              </CardContent>

              <DialogFooter
                htmlElements={
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      // className={classes.btnCreateGoal}
                      type="submit"
                      disabled={!this.state.activateCreateCourseBtn}
                      onClick={this.handleSubmit}
                    >
                      Create Course
                    </Button>
                  </>
                }
              />
            </Card>
            {/* {
                true && 
                <CreateCoursePopup 
                open={true}
                createRequestOpen={true}
                onClose={() => console.log()}
                />
        } */}
          </div>
          </Modal>
        );
    }
}

const mapStateToProps = (state: any) => ({
    goals: state.courseMangementData.courseManagementReducer.activeGoals,
    duplicateSKUMessage: state.courseMangementData.courseManagementReducer.errors.duplicateSKUMessage,
    userSuggestions:
        state.courseMangementData.courseManagementReducer.userSuggestions,
    packageId: state.courseMangementData.courseManagementReducer.packageId,
});

const mapDispatchToProps = (dispatch: any) =>
    bindActionCreators(
        {
            getActiveGoals: getActiveGoals,
            getUserSuggestions: getUserSuggestions,
            addCourseBasicDetails: addCourseBasicDetails
        },
        dispatch
    );

// @ts-ignore
export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(courseStyles)(withRouter(CreateNewCourse)));
